import React, { useState } from 'react';
import {
  VertModal,
  VertContainer,
  Row,
  Col,
  VertButton,
  Typography,
  notification,
} from '@vertem-core/vertice-ds';
import { useSelector } from 'react-redux';
import { formatDocument } from 'Utils/format';
import { useSimulationLocalStorageContext } from 'Context/SimulationLocalSotrageContext';
import { cloudloyalty } from 'Services/Apis/clients';

const OpenParticipantCatalogModal = ({
  isOpen,
  onClose,
  participantDocumentNumber,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { saldoParticipante, walletParticipant, dataParticipant } = useSelector(
    (state) => state.SpotNewSolicitation
  );
  const { setSimulationLocalStorageValue } = useSimulationLocalStorageContext();

  const accessToken = useSelector((state) => state.oidc.user.access_token);

  const findNameOfParticipantSelectedForHierarchy = ({ maxNameSize }) => {
    const participantName = walletParticipant?.find(
      (item) => item.cpfCnpj === participantDocumentNumber
    )?.name;

    if (participantName?.length > maxNameSize) {
      return participantName.substring(0, maxNameSize) + '...';
    } else {
      return participantName;
    }
  };

  const createSimulatedParticipantInfo = async () => {
    setIsLoading(true);
    try {
      await cloudloyalty({
        access_token: `Bearer ${accessToken}`,
      }).post(`v1/participants/impersonate/${dataParticipant?.id}`);

      setSimulationLocalStorageValue({
        balance: saldoParticipante,
        name: dataParticipant?.name,
        participantId: dataParticipant?.id,
        userName: dataParticipant?.username,
        label: `${dataParticipant.name} - ${formatDocument(
          dataParticipant?.documentNumber
        )}`,
        enabled: true,
      });
      setIsLoading(false);
      notification.success({
        message: `Você está agora impersonando o participante ${findNameOfParticipantSelectedForHierarchy(
          { maxNameSize: 30 }
        )}`,
      });
      onClose();
    } catch (error) {
      notification.error({
        message: 'Você ainda não está impersonando o participante.',
        description: 'Tente novamente!',
      });
      setIsLoading(false);
    }
  };

  return (
    <VertModal
      destroyOnClose={false}
      open={isOpen}
      onCancel={onClose}
      footer={
        <VertContainer className="col-12">
          <Row gutter={[16, 16]}>
            <Col lg={12} md={12} sm={24} xs={24}>
              <VertButton className="col-12" type="default" onClick={onClose}>
                CANCELAR
              </VertButton>
            </Col>
            <Col lg={12} md={12} sm={24} xs={24}>
              <VertButton
                loading={isLoading}
                className="col-12"
                type="highlight"
                onClick={createSimulatedParticipantInfo}
              >
                ACESSAR
              </VertButton>
            </Col>
          </Row>
        </VertContainer>
      }
    >
      <VertContainer>
        <Typography.Title level={2} style={{ color: 'var(--color-detached)' }}>
          {`Deseja ACESSAR por ${findNameOfParticipantSelectedForHierarchy({
            maxNameSize: 25,
          })}?`}
        </Typography.Title>
        <Typography.Text style={{ color: 'var(--color-detached)' }}>
          {'Ao clicar em'}
        </Typography.Text>
        <Typography.Text strong style={{ color: 'var(--color-detached)' }}>
          {' ACESSAR'}
        </Typography.Text>
        <Typography.Text
          style={{ color: 'var(--color-detached)' }}
        >{` você entrará no modo de simulação de 
          catálogo e poderá realizar a solicitação
          de resgate pelo participante`}</Typography.Text>
        <Typography.Text strong style={{ color: 'var(--color-detached)' }}>
          {` "${findNameOfParticipantSelectedForHierarchy({
            maxNameSize: 25,
          })}".`}
        </Typography.Text>
      </VertContainer>
    </VertModal>
  );
};

export default OpenParticipantCatalogModal;
